<template>
  <div>
    <DataTable
      :value="roles"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedRoles"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} roles"
    >
      <template #empty> No roles found. </template>
      <template #loading> Loading roles data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="roleName"
        header="Role Name"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.roleName }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column
        field="createdByName"
        header="Created By"
        headerStyle="width: 15em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.createdByName }}
          </div>
        </template>
      </Column>
      <Column
        field="updatedByName"
        header="Updated By"
        headerStyle="width: 15em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.updatedByName }}
          </div>
        </template>
      </Column>
      <Column headerStyle="width: 9rem;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="View" 
              icon="pi pi-info" 
              @click="viewRole(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  props: [
    'roles',
    'loading'
  ],
  data: () => ({
    selectedRoles: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) {
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
            this.$emit('edit-role',  data)
					}
				},
				{
					label: 'View Permissions',
					icon: 'pi pi-inbox',
					command: () => {
            this.viewPermissions(data)
					}
				}
      ]

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteRole(data)
          }
        }
      )
      return buttons
    },
    viewRole(role) {
      if (role && role.id)
        this.$router.push({
          path: "roles/" + role.id + "/detail",
          params: { roleid: role.id },
        });
    },
    viewPermissions(role) {
      if (role && role.id)
        this.$router.push({
          path: "roles/" + role.id + "/permissions",
          params: { roleid: role.id },
        });
    },
    deleteRole(role) {
    }
  }
}
</script>

<style>

</style>